import React, { useEffect, useState, useRef } from "react";
import FullLoader from "../assets/images/full-page-loader.gif";
import addIcon from '../assets/images/addbtnicon/plusicon.svg';
import Cookies from "js-cookie";
import { Link } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import axios from "axios";
import configData from "../config/config.json";
import { notifysuccess } from "../utils/toast";
import { notifyfailure } from "../utils/toast";
import backButton from '../assets/images/back_button_arrow.svg';
import { notifycatch } from "../utils/toast";
import { Radio, Select, Col, Row, Input, Checkbox, Tooltip, Modal } from "antd";
import loaderIcon from "../assets/images/login-and-signup/loader.gif";
import deleteIcon from '../assets/images/icons/trash.svg';
import playIcon from '../assets/images/icons/play.svg';
import zoneIcon from '../assets/images/icons/zone.svg';

const ZoneViewEdit = ({ handlePageViewChange, id, zoneCategory, zoneViewName }) => {
    // const loadingContext = useContext(LoadingContext);
    const [formVisible, setFormVisible] = useState(false);

    useEffect(() => {
        const inputs = document.querySelectorAll('.ant-select-selection-search-input');

        inputs.forEach(input => {
            const handleInput = () => {
                const parent = input.closest('.ant-select-selection-search');
                if (input.value.length > 0) {
                    parent.classList.add('searching');
                } else {
                    parent.classList.remove('searching');
                }
            };

            input.addEventListener('input', handleInput);

            // Cleanup event listener on component unmount
            return () => {
                input.removeEventListener('input', handleInput);
            };
        });
    });

    useEffect(() => {
        setFormType(zoneCategory)
        let status = Cookies.get("token_xapads_ssp") ? true : false;
        if (status) {
            let token = Cookies.get("token_xapads_ssp");
            let role = jwtDecode(token).role;

            if (role === "mobops" || role === "sa") {
                axios
                    .get(configData.SERVER_URL + "ops/getExchangeTypes", {
                        headers: {
                            "Content-Type": "application/json",
                        },
                    })
                    .then((response) => {
                        setIntegrationTypeOptions_openrtb(response.data.data);
                    })
                    .catch((error) => { });


                axios
                    .get(configData.SERVER_URL + "remotefeed/feedTypeList", {
                        headers: {
                            "Content-Type": "application/json",
                        },
                    })
                    .then((response) => {
                        setFeedListRepeaterOptions(response.data.data)
                    })
                    .catch((error) => { });


            }

            setRole(role);

            axios
                .get(configData.SERVER_URL + "zone/zoneDetails?zoneId=" + id, {
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": token,
                    },
                })
                .then((response) => {
                    if (zoneCategory === "Prebid") {
                        setPlatformType_prebid(response.data.data.invent_type)
                        setFormatType_prebid(
                            response.data.data.traffic_type
                                ? response.data.data.traffic_type.split(",").map(item => item.trim())
                                : []
                        );


                        if (response.data.data.traffic_type?.includes("Banner")) {
                            setBannerCheckbox_prebid(response.data.data.bannerCheckbox)
                        }
                        setZoneName_prebid(response.data.data.z_name)
                        setZoneActiveCheckbox_prebid(response.data.data.status)
                        setIntegrationType_prebid(response.data.data.exchange_type)
                        setImpression_prebid(response.data.data.imp_daily)
                        setRequest_prebid(response.data.data.req_daily)

                        let tempArr = []
                        if (response.data.data.remoteIds.length > 0) {
                            tempArr = response.data.data.remoteIds.map(item => ({
                                ...item,
                                validation_feed_provider_id: false,
                                validation_remote_id: false
                            }))
                        }

                        setFeedListRepeaterOldData(JSON.parse(JSON.stringify(tempArr)));
                        setFeedListRepeater(tempArr);

                    }

                    else if (zoneCategory === "Open RTB") {

                        setPlatformType_openrtb(response.data.data.invent_type)
                        setFormatType_openrtb(response.data.data.traffic_type
                            ? response.data.data.traffic_type.split(",").map(item => item.trim())
                            : [])
                        if (response.data.data.traffic_type?.includes("Banner")) {
                            setBannerCheckbox_openrtb(response.data.data.bannerCheckbox)
                        }
                        setZoneName_openrtb(response.data.data.z_name)
                        setZoneActiveCheckbox_openrtb(response.data.data.status)
                        setIntegrationType_openrtb(response.data.data.exchange_type)
                        setImpression_openrtb(response.data.data.imp_daily)
                        setRequest_openrtb(response.data.data.req_daily)

                        let tempArr = []
                        if (response.data.data.remoteIds.length > 0) {
                            tempArr = response.data.data.remoteIds.map(item => ({
                                ...item,
                                validation_feed_provider_id: false,
                                validation_remote_id: false
                            }))
                        }


                        setFeedListRepeaterOldData(JSON.parse(JSON.stringify(tempArr)));
                        setFeedListRepeater(tempArr);

                    }

                    else if (zoneCategory === "GAM Tag") {

                        setAccountName_gamtag(response.data.data.z_name)
                        setPlatformType_gamtag(response.data.data.invent_type)
                        setOwnership_gamtag(response.data.data.gamData?.ownership)
                        setVastVersion_gamtag(response.data.data.gamData?.vastVersion)
                        seteCPM_gamtag(response.data.data.gamData?.ecpm)

                    }

                    else if (zoneCategory === "Vast Zone") {
                        setPlatformType_vastzone(response.data.data.invent_type)
                        setStreamPosition_vastzone(response.data.data.stream_position)
                        setZoneName_vastzone(response.data.data.z_name)
                        setZoneActiveCheckbox_vastzone(response.data.data.status)
                        setRevenueType_vastzone(response.data.data.revenue_type)
                        setRevenueType_vastzone_prev(response.data.data.revenue_type)
                        if (response.data.data.revenue_type === "Fixed_Price") {
                            setECpm_vastzone(response.data.data.fixed_cpm)
                            setECpm_vastzone_prev(response.data.data.fixed_cpm)

                        }
                        if (response.data.data.revenue_type === "Revshare") {
                            setRevSharePercent_vastzone(response.data.data.revshare)
                            setRevSharePercent_vastzone_prev(response.data.data.revshare)
                        }
                        setRequest_vastzone(response.data.data.req_daily)
                        setImpression_vastzone(response.data.data.imp_daily)

                        let tempArr = []
                        if (response.data.data.remoteIds.length > 0) {
                            tempArr = response.data.data.remoteIds.map(item => ({
                                ...item,
                                validation_feed_provider_id: false,
                                validation_remote_id: false
                            }))
                        }

                        setFeedListRepeaterOldData(JSON.parse(JSON.stringify(tempArr)));
                        setFeedListRepeater(tempArr);

                    }


                    else if (zoneCategory === "vast_aniview") {
                        setPlatformType_vast_aniview(response.data.data.invent_type)
                        setPlatformType_vast_aniview_prev(response.data.data.invent_type)
                        setChannelName_vast_aniview(response.data.data.z_name)
                        setChannelName_vast_aniview_prev(response.data.data.z_name)
                        setECpm_vast_aniview(response.data.data.fixed_cpm)
                        setECpm_vast_aniview_prev(response.data.data.fixed_cpm)
                        setp_name_vast_aniview(response.data.data.p_name)
                        setp_aniviewId_vast_aniview(response.data.data.p_aniviewId)
                    }



                    else if (zoneCategory === "Player Tag" || zoneCategory === "tag_outstream") {
                        setPlatformType_playertag(response.data.data.invent_type)
                        setPlayerMode_playertag(response.data.data.playerMode)
                        setFloatingPosition_playertag(response.data.data.floatingPos)
                        setFloatingPosition_playertag_prev(response.data.data.floatingPos)
                        setChannelName_playertag(response.data.data.aniviewData?.channel?.channelName)
                        setECpm_playertag(response.data.data.fixed_cpm)
                        setMainTableVideo_playertag(response.data.data.aniviewData?.videoIds)

                    }


                    setFormVisible(true)
                })
                .catch((error) => {
                    setFormVisible(true)
                    notifyfailure("Failed to fetch the zone details.")
                });
        }
    }, [])


    const [floatingPosition_playertag_prev, setFloatingPosition_playertag_prev] = useState("");
    const [revenueType_vastzone_prev, setRevenueType_vastzone_prev] = useState("");
    const [eCpm_vastzone_prev, setECpm_vastzone_prev] = useState("");
    const [revSharePercent_vastzone_prev, setRevSharePercent_vastzone_prev] = useState("");

    ////////////////////////////////////////////role and publisher list/publisher for not admin states  and form view////////////////////////////////

    function resetFormView() {
        setButtonProcessing(false)
        setFormType("")
        setFormVisible(false)
        reset_prebid()
        reset_openrtb()
        reset_gamtag()
        reset_playertag()
        reset_vastzone()
        reset_vast_aniview()
        setFloatingPosition_playertag_prev("");
        setRevenueType_vastzone_prev("");
        setECpm_vastzone_prev("");
        setRevSharePercent_vastzone_prev("");
        setPlatformType_vast_aniview_prev("");
        setChannelName_vast_aniview_prev("");
        setECpm_vast_aniview_prev("");
    }

    const [role, setRole] = useState("admin");
    const [buttonProcessing, setButtonProcessing] = useState(false);


    const [formType, setFormType] = useState("");
    const [formTypeOption, setFormTypeOption] = useState([
        { label: "Prebid", value: "Prebid" },
        { label: "Open RTB", value: "Open RTB" },
        { label: "Vast (ADK)", value: "Vast Zone" },
        { label: "Vast (Aniview)", value: "vast_aniview" },
        { label: "Player Tag (Instream)", value: "Player Tag" },
        { label: "Player Tag (Outstream)", value: "tag_outstream" },
        { label: "GAM Tag", value: "GAM Tag" },
    ]);





    const [feedListRepeaterOptions, setFeedListRepeaterOptions] = useState([])
    const [feedListRepeater, setFeedListRepeater] = useState([]);
    const [feedListRepeaterOldData, setFeedListRepeaterOldData] = useState([]);


    const handleChangeFeedProviderId = (e, index) => {
        const listTrigger = [...feedListRepeater];
        listTrigger[index]["feed_provider_id"] = e;
        listTrigger[index]["validation_feed_provider_id"] = false;
        setFeedListRepeater(listTrigger);
    };

    const handleChangeRemoteId = (e, index) => {
        const listTrigger = [...feedListRepeater];
        if (/^[\d\W]*$/.test(e.target.value.trim())) {

            listTrigger[index]["remote_id"] = e.target.value.trim();
            if (e.target.value.trim().length === 0) {
                listTrigger[index]["validation_remote_id"] = true;
            }
            else {
                listTrigger[index]["validation_remote_id"] = false;
            }
            setFeedListRepeater(listTrigger);
        }

    };

    const handleRemoveFeedListRepeater = (index) => {
        let listTrigger = [...feedListRepeater];
        listTrigger.splice(index, 1);
        setFeedListRepeater(listTrigger);
    };

    const handleAddFeedListRepeater = () => {
        setFeedListRepeater([
            ...feedListRepeater,
            {
                feed_provider_id: "",
                remote_id: "",
                validation_feed_provider_id: false,
                validation_remote_id: false
            },
        ]);
    };




    const validateFeedListRepeater = () => {
        setFeedListRepeater(prevFeedListRepeater =>
            prevFeedListRepeater.map(item => {
                const isFeedProviderIdEmpty = item.feed_provider_id === "";
                const isRemoteIdEmpty = item.remote_id === "";

                return {
                    ...item,
                    validation_feed_provider_id: isFeedProviderIdEmpty, // Set to true if feed_provider_id is empty
                    validation_remote_id: isRemoteIdEmpty // Set to true if remote_id is empty
                };
            })
        );

        // Return true if all fields are filled, false if any are empty
        return feedListRepeater.every(item => item.feed_provider_id !== "" && item.remote_id !== "");
    };



    /////////////////////////////////////////////////////prebaid code /////////////////////////////////////////
    const [platformType_prebid, setPlatformType_prebid] = useState("");
    const [formatType_prebid, setFormatType_prebid] = useState([]);
    const [formatTypeIsRequiredError_prebid, setFormatTypeIsRequiredError_prebid] = useState(false);
    // const [formatTypeOptions_prebid, setFormatTypeOptions_prebid] = useState([
    //     { label: "Banner", value: "Banner" },
    //     { label: "Video", value: "Video" },
    //     { label: "Native", value: "Native" },
    // ]);
    const [integrationType_prebid, setIntegrationType_prebid] =
        useState("");
    const [integrationTypeOptions_prebid, setIntegrationTypeOptions_prebid] =
        useState([
            { label: "OpenRTB (Both ADM and nURL)", value: "OPEN_RTB" },
            { label: "ADM (OpenRtb w/o nurl)", value: "OPEN_RTB_WO_NURL" },
            { label: "nURL (OpenRtb nurl only)", value: "OPEN_RTB_NURL_ONLY" },
        ]);
    const [bannerCheckbox_prebid, setBannerCheckbox_prebid] = useState(null);


    const [zoneActiveCheckbox_prebid, setZoneActiveCheckbox_prebid] =
        useState(true);
    const [zoneName_prebid, setZoneName_prebid] = useState("");

    const [request_prebid, setRequest_prebid] = useState("");
    const [impression_prebid, setImpression_prebid] = useState("");

    function reset_prebid() {
        setPlatformType_prebid("");
        setFormatType_prebid([]);
        // setFormatTypeOptions_prebid([
        //     { label: "Banner", value: "Banner" },
        //     { label: "Video", value: "Video" },
        //     { label: "Native", value: "Native" },
        // ]);
        setIntegrationType_prebid("");
        setIntegrationTypeOptions_prebid([
            { label: "OpenRTB (Both ADM and nURL)", value: "OPEN_RTB" },
            { label: "ADM (OpenRtb w/o nurl)", value: "OPEN_RTB_WO_NURL" },
            { label: "nURL (OpenRtb nurl only)", value: "OPEN_RTB_NURL_ONLY" },
        ]);
        setBannerCheckbox_prebid(null);
        setZoneActiveCheckbox_prebid(true);
        setZoneName_prebid("");
        setRequest_prebid("");
        setImpression_prebid("");
    }

    ///////////////////////////////////////////////////open rtb code ///////////////////////////////////////////
    const [platformType_openrtb, setPlatformType_openrtb] = useState("");
    const [formatType_openrtb, setFormatType_openrtb] = useState([]);

    const [integrationType_openrtb, setIntegrationType_openrtb] =
        useState("");
    const [integrationTypeOptions_openrtb, setIntegrationTypeOptions_openrtb] =
        useState([
            { label: "OpenRTB (Both ADM and nURL)", value: "OPEN_RTB" },
            { label: "ADM (OpenRtb w/o nurl)", value: "OPEN_RTB_WO_NURL" },
            { label: "nURL (OpenRtb nurl only)", value: "OPEN_RTB_NURL_ONLY" },
        ]);

    const [bannerCheckbox_openrtb, setBannerCheckbox_openrtb] = useState(null);
    const [zoneActiveCheckbox_openrtb, setZoneActiveCheckbox_openrtb] =
        useState(true);
    const [zoneName_openrtb, setZoneName_openrtb] = useState("");
    const [request_openrtb, setRequest_openrtb] = useState("");
    const [impression_openrtb, setImpression_openrtb] = useState("");


    function reset_openrtb() {
        setPlatformType_openrtb("");
        setFormatType_openrtb([]);

        setIntegrationType_openrtb("");
        // setIntegrationTypeOptions_openrtb([
        //     { label: "OpenRTB (Both ADM and nURL)", value: "OPEN_RTB" },
        //     { label: "ADM (OpenRtb w/o nurl)", value: "OPEN_RTB_WO_NURL" },
        //     { label: "nURL (OpenRtb nurl only)", value: "OPEN_RTB_NURL_ONLY" },
        // ]);
        setBannerCheckbox_openrtb(null);
        setZoneActiveCheckbox_openrtb(true);
        setZoneName_openrtb("");
        setRequest_openrtb("");
        setImpression_openrtb("");
    }


    ///////////////////////////////////////////////////vast zone code ///////////////////////////////////////////

    const [platformType_vastzone, setPlatformType_vastzone] = useState("");

    const [streamPosition_vastzone, setStreamPosition_vastzone] = useState("");
    const [streamPositionOptions_vastzone, setStreamPositionOptions_vastzone] = useState([
        { label: "Outstream", value: "Outstream" },
        { label: "Instream", value: "Instream" },
    ]);

    const [zoneActiveCheckbox_vastzone, setZoneActiveCheckbox_vastzone] =
        useState(true);
    const [zoneName_vastzone, setZoneName_vastzone] = useState("");



    const [revenueType_vastzone, setRevenueType_vastzone] = useState("");
    const [revenueTypeOptions_vastzone, setRevenueTypeOptions_vastzone] = useState([
        { label: "Fixed Price", value: "Fixed_Price" },
        { label: "Revshare", value: "Revshare" },
    ]);

    const [eCpm_vastzone, setECpm_vastzone] = useState("");
    const [eCpmIsRequiredError_vastzone, setECpmIsRequiredError_vastzone] = useState(false);
    const [eCpmValidError_vastzone, setECpmValidError_vastzone] = useState(false);


    const [revSharePercent_vastzone, setRevSharePercent_vastzone] = useState("");
    const [revSharePercentIsRequiredError_vastzone, setRevSharePercentIsRequiredError_vastzone] = useState(false);
    const [revSharePercentValidError_vastzone, setRevSharePercentValidError_vastzone] = useState(false);

    const [request_vastzone, setRequest_vastzone] = useState("");
    const [impression_vastzone, setImpression_vastzone] = useState("");


    function reset_vastzone() {
        setPlatformType_vastzone("");
        setStreamPosition_vastzone("");
        setStreamPositionOptions_vastzone([
            { label: "Outstream", value: "Outstream" },
            { label: "Instream", value: "Instream" },
        ]);

        setZoneActiveCheckbox_vastzone(true);
        setZoneName_vastzone("");

        setRevenueType_vastzone("");
        setRevenueTypeOptions_vastzone([
            { label: "Fixed Price", value: "Fixed_Price" },
            { label: "Revshare", value: "Revshare" },
        ]);
        setECpm_vastzone("");
        setECpmIsRequiredError_vastzone(false);
        setECpmValidError_vastzone(false);
        setRevSharePercent_vastzone("");
        setRevSharePercentIsRequiredError_vastzone(false);
        setRevSharePercentValidError_vastzone(false);
    }


    function onChangeECpm_vastzone(event) {
        setECpmIsRequiredError_vastzone(false);
        if (/^\d*\.?\d*$/.test(event.target.value.trim())) {
            setECpm_vastzone(event.target.value.trim());
            if (Number(event.target.value.trim()) > 0 && Number(event.target.value.trim()) < 100) {
                setECpmValidError_vastzone(false)
            }
            else {
                setECpmValidError_vastzone(true)
            }
        }
    }

    function onBlurECpm_vastzone(event) {
        if (event.target.value.trim().length === 0) {
            setECpmValidError_vastzone(false);
            setECpmIsRequiredError_vastzone(true);
        } else {
            if (Number(event.target.value.trim()) > 0 && Number(event.target.value.trim()) < 100) {
                setECpmValidError_vastzone(false);
            } else {
                setECpmIsRequiredError_vastzone(false);
                setECpmValidError_vastzone(true);
            }
        }
        setECpm_vastzone(event.target.value.trim());
    }

    function onChangeRevSharePercent_vastzone(event) {
        setRevSharePercentIsRequiredError_vastzone(false);
        if (/^\d*\.?\d*$/.test(event.target.value.trim())) {
            setRevSharePercent_vastzone(event.target.value.trim());
            if (Number(event.target.value.trim()) > 0 && Number(event.target.value.trim()) <= 80) {
                setRevSharePercentValidError_vastzone(false)
            }
            else {
                setRevSharePercentValidError_vastzone(true)
            }
        }
    }

    function onBlurRevSharePercent_vastzone(event) {
        if (event.target.value.trim().length === 0) {
            setRevSharePercentValidError_vastzone(false);
            setRevSharePercentIsRequiredError_vastzone(true);
        } else {
            if (Number(event.target.value.trim()) > 0 && Number(event.target.value.trim()) <= 80) {
                setRevSharePercentValidError_vastzone(false);
            } else {
                setRevSharePercentIsRequiredError_vastzone(false);
                setRevSharePercentValidError_vastzone(true);
            }
        }
        setRevSharePercent_vastzone(event.target.value.trim());
    }

    ///////////////////////////////////////////////////vast aniview tag code ///////////////////////////////////////////
    const [p_name_vast_aniview, setp_name_vast_aniview] = useState("");
    const [p_aniviewId_vast_aniview, setp_aniviewId_vast_aniview] = useState("");
    const [platformType_vast_aniview, setPlatformType_vast_aniview] = useState("Website");
    const [platformType_vast_aniview_prev, setPlatformType_vast_aniview_prev] = useState("");

    const [channelName_vast_aniview, setChannelName_vast_aniview] = useState("");
    const [channelName_vast_aniview_prev, setChannelName_vast_aniview_prev] = useState("");
    const [channelNameIsRequiredError_vast_aniview, setChannelNameIsRequiredError_vast_aniview] =
        useState(false);

    const [eCpm_vast_aniview, setECpm_vast_aniview] = useState("");
    const [eCpm_vast_aniview_prev, setECpm_vast_aniview_prev] = useState("");
    const [eCpmIsRequiredError_vast_aniview, setECpmIsRequiredError_vast_aniview] = useState(false);
    const [eCpmValidError_vast_aniview, setECpmValidError_vast_aniview] = useState(false);

    function reset_vast_aniview() {
        setPlatformType_vast_aniview("Website");
        setChannelName_vast_aniview("");
        setChannelNameIsRequiredError_vast_aniview(false);
        setECpm_vast_aniview("");
        setECpmIsRequiredError_vast_aniview(false);
        setECpmValidError_vast_aniview(false);
    }

    function onChangePlatformType_vast_aniview(event) {
        setPlatformType_vast_aniview(event.target.value);

        //    if (publisherName !== "") {
        //      setChannelName_vast_aniview(
        //        publisherName + "_" + event.target.value 
        //      );
        //    }
        //    setChannelNameIsRequiredError_vast_aniview(false);
    }

    function onChangeChannelName_vast_aniview(event) {
        setChannelNameIsRequiredError_vast_aniview(false);
        setChannelName_vast_aniview(event.target.value);
    }

    function onBlurChannelName_vast_aniview(event) {
        if (event.target.value.trim().length === 0) {
            setChannelNameIsRequiredError_vast_aniview(true);
        }
        setChannelName_vast_aniview(event.target.value.trim());
    }



    function onChangeECpm_vast_aniview(event) {
        setECpmIsRequiredError_vast_aniview(false);
        if (/^\d*\.?\d{0,2}$/.test(event.target.value.trim())) {
            setECpm_vast_aniview(event.target.value.trim());
            if (Number(event.target.value.trim()) > 0 && Number(event.target.value.trim()) < 100) {
                setECpmValidError_vast_aniview(false)
            }
            else {
                setECpmValidError_vast_aniview(true)
            }
        }
    }

    function onBlurECpm_vast_aniview(event) {
        if (event.target.value.trim().length === 0) {
            setECpmValidError_vast_aniview(false);
            setECpmIsRequiredError_vast_aniview(true);
        } else {
            if (Number(event.target.value.trim()) > 0 && Number(event.target.value.trim()) < 100) {
                setECpmValidError_vast_aniview(false);
            } else {
                setECpmIsRequiredError_vast_aniview(false);
                setECpmValidError_vast_aniview(true);
            }
        }
        setECpm_vast_aniview(event.target.value.trim());
    }

    ///////////////////////////////////////////////////player tag code ///////////////////////////////////////////

    const [mainTableVideo_playertag, setMainTableVideo_playertag] = useState([]);
    const [platformType_playertag, setPlatformType_playertag] = useState("");

    const [playerMode_playertag, setPlayerMode_playertag] = useState("");
    const [playerModeOptions_playertag, setPlayerModeOptions_playertag] = useState([
        { label: "Article Video", value: "articleVideo" },
        { label: "Banner Video", value: "bannerVideo" },
    ]);

    const [floatingPosition_playertag, setFloatingPosition_playertag] = useState("");
    const [floatingPositionOptions_playertag, setFloatingPositionOptions_playertag] = useState([
        { label: "Bottom Right", value: "bottomRight" },
        { label: "Bottom Left", value: "bottomLeft" },
        { label: "Top Right", value: "topRight" },
        { label: "Top Left", value: "topLeft" },
        { label: "Top Center", value: "topCenter" },
        { label: "Bottom Center", value: "bottomCenter" },
    ]);
    const [floatingPositionOptions_tag_outstream, setFloatingPositionOptions_tag_outstream] = useState([
        { label: "Default", value: "default" },
        { label: "Top Right", value: "topRight" },
        { label: "Top Left", value: "topLeft" },
    ]);

    const [channelName_playertag, setChannelName_playertag] = useState("");

    const [eCpm_playertag, setECpm_playertag] = useState("");

    function reset_playertag() {

        setPlatformType_playertag("");
        setPlayerMode_playertag("");
        setPlayerModeOptions_playertag([
            { label: "Article Video", value: "articleVideo" },
            { label: "Banner Video", value: "bannerVideo" },
        ]);

        setFloatingPosition_playertag("");
        setChannelName_playertag("");
        setECpm_playertag("");
        setMainTableVideo_playertag([])

    }



    function onChangeFloatingPosition_playertag(event) {
        setFloatingPosition_playertag(event);
    }

    // ///////////////////////////////Player tag modal related code ////////////////////////////////
    const videoRef1 = useRef([]);

    const handleFullscreen1 = (index) => {
        const videoElement = videoRef1.current[index];
        if (videoElement) {
            videoElement.currentTime = 0;

            if (videoElement.requestFullscreen) {
                videoElement.requestFullscreen();
            } else if (videoElement.mozRequestFullScreen) { /* Firefox */
                videoElement.mozRequestFullScreen();
            } else if (videoElement.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
                videoElement.webkitRequestFullscreen();
            } else if (videoElement.msRequestFullscreen) { /* IE/Edge */
                videoElement.msRequestFullscreen();
            }
        }
    };



    ///////////////////////////////////////////////////gam tag code ///////////////////////////////////////////

    const [accountName_gamtag, setAccountName_gamtag] = useState("");

    const [platformType_gamtag, setPlatformType_gamtag] = useState("");
    const [ownership_gamtag, setOwnership_gamtag] = useState("");
    const [ownershipOptions_gamtag, setOwnershipOptions_gamtag] = useState([
        { label: "Own", value: "Own" },
        { label: "Re-seller", value: "Re-seller" },
    ]);

    const [vastVersion_gamtag, setVastVersion_gamtag] = useState("");
    const [vastVersionOptions_gamtag, setVastVersionOptions_gamtag] = useState([
        { label: "VAST 2", value: "VAST 2" },
        { label: "VAST 3", value: "VAST 3" },
        { label: "VAST 4", value: "VAST 4" },
    ]);

    const [eCPM_gamtag, seteCPM_gamtag] = useState(null);
    const [eCPMOptions_gamtag, seteCPMOptions_gamtag] = useState([
        { label: "0.20", value: 0.20 },
        { label: "0.40", value: 0.40 },
        { label: "0.80", value: 0.80 },
        { label: "1.00", value: 1.00 },
        { label: "1.20", value: 1.20 }
    ]);

    function reset_gamtag() {
        setAccountName_gamtag("");

        setPlatformType_gamtag("");
        setOwnership_gamtag("");
        setOwnershipOptions_gamtag([
            { label: "Own", value: "Own" },
            { label: "Re-seller", value: "Re-seller" },
        ]);
        setVastVersion_gamtag("");
        setVastVersionOptions_gamtag([
            { label: "VAST 2", value: "VAST 2" },
            { label: "VAST 3", value: "VAST 3" },
            { label: "VAST 4", value: "VAST 4" },
        ]);
        seteCPM_gamtag(null);
        seteCPMOptions_gamtag([
            { label: 0.20, value: 0.20 },
            { label: 0.40, value: 0.40 },
            { label: 0.80, value: 0.80 },
            { label: 1.00, value: 1.00 },
            { label: 1.20, value: 1.20 }
        ]);
    }


    ///////////////////////////////////////submit //////////////////////////////////////////////////////////////////

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (formType === "Prebid") {

            let feedListRepeaterTemp = []
            if (validateFeedListRepeater()) {
                if (feedListRepeater.length > 0) {
                    feedListRepeaterTemp = feedListRepeater.map(({ validation_feed_provider_id, validation_remote_id, ...rest }) => rest)
                }

                let payload = {
                    remoteIds: feedListRepeaterTemp,
                };

                setButtonProcessing(true)

                let status = Cookies.get("token_xapads_ssp") ? true : false;
                if (status) {

                    let token = Cookies.get("token_xapads_ssp");

                    axios
                        .put(configData.SERVER_URL + `zone/editPrebidZone?zoneId=` + id, payload, {
                            headers: {
                                'Content-Type': 'application/json',
                                "x-access-token": token,
                            },
                        })
                        .then((response) => {
                            notifysuccess(response.data.message);
                            handlePageViewChange("table", "yes")
                            resetFormView()

                        })
                        .catch((error) => {
                            if (error?.response) {
                                if (error.response.data.message?.length !== 0) {
                                    notifyfailure(error.response.data.message);
                                    setButtonProcessing(false)
                                }
                            } else {
                                notifycatch();
                                setButtonProcessing(false)
                            }

                        });
                }

            }

        }

        if (formType === "Open RTB") {

            let feedListRepeaterTemp = []
            if (validateFeedListRepeater()) {
                if (feedListRepeater.length > 0) {

                    feedListRepeaterTemp = feedListRepeater.map(({ validation_feed_provider_id, validation_remote_id, ...rest }) => rest)

                }


                let payload = {
                    remoteIds: feedListRepeaterTemp,
                };

                setButtonProcessing(true)

                let status = Cookies.get("token_xapads_ssp") ? true : false;
                if (status) {

                    let token = Cookies.get("token_xapads_ssp");

                    axios
                        .put(configData.SERVER_URL + `zone/editORTBZone?zoneId=` + id, payload, {
                            headers: {
                                'Content-Type': 'application/json',
                                "x-access-token": token,
                            },
                        })
                        .then((response) => {
                            notifysuccess(response.data.message);
                            handlePageViewChange("table", "yes")
                            resetFormView()

                        })
                        .catch((error) => {
                            if (error?.response) {
                                if (error.response.data.message?.length !== 0) {
                                    notifyfailure(error.response.data.message);
                                    setButtonProcessing(false)
                                }
                            } else {
                                notifycatch();
                                setButtonProcessing(false)
                            }

                        });
                }

            }

        }

        if (formType === "Vast Zone") {

            if (
                (revenueType_vastzone === "Fixed_Price" ? eCpm_vastzone !== "" : true) &&
                (revenueType_vastzone === "Revshare" ? revSharePercent_vastzone !== "" : true)
            ) {
                if (
                    (revenueType_vastzone === "Fixed_Price" ? eCpmIsRequiredError_vastzone === false : true) &&
                    (revenueType_vastzone === "Fixed_Price" ? eCpmValidError_vastzone === false : true) &&
                    (revenueType_vastzone === "Revshare" ? revSharePercentIsRequiredError_vastzone === false : true) &&
                    (revenueType_vastzone === "Revshare" ? revSharePercentValidError_vastzone === false : true)
                ) {

                    let feedListRepeaterTemp = []
                    if (validateFeedListRepeater()) {
                        if (feedListRepeater.length > 0) {

                            feedListRepeaterTemp = feedListRepeater.map(({ validation_feed_provider_id, validation_remote_id, ...rest }) => rest)

                        }

                        let payload =
                            revenueType_vastzone === "Fixed_Price"
                                ? {
                                    revenue_type: revenueType_vastzone,
                                    fixed_cpm: Number(eCpm_vastzone),
                                    remoteIds: feedListRepeaterTemp,


                                }
                                : {

                                    revenue_type: revenueType_vastzone,
                                    revshare: Number(revSharePercent_vastzone),
                                    remoteIds: feedListRepeaterTemp,
                                };

                        setButtonProcessing(true)


                        let status = Cookies.get("token_xapads_ssp") ? true : false;
                        if (status) {

                            let token = Cookies.get("token_xapads_ssp");

                            axios
                                .put(configData.SERVER_URL + `zone/editVastZone?zoneId=` + id, payload, {
                                    headers: {
                                        'Content-Type': 'application/json',
                                        "x-access-token": token,
                                    },
                                })
                                .then((response) => {
                                    notifysuccess(response.data.message);
                                    handlePageViewChange("table", "yes")
                                    resetFormView()

                                })
                                .catch((error) => {
                                    if (error?.response) {
                                        if (error.response.data.message?.length !== 0) {
                                            notifyfailure(error.response.data.message);
                                            setButtonProcessing(false)
                                        }
                                    } else {
                                        notifycatch();
                                        setButtonProcessing(false)
                                    }

                                });
                        }
                    }

                }


            } else {

                if (revenueType_vastzone === "Fixed_Price" && eCpm_vastzone === "") {
                    setECpmIsRequiredError_vastzone(true);
                }
                if (revenueType_vastzone === "Revshare" && revSharePercent_vastzone === "") {
                    setRevSharePercentIsRequiredError_vastzone(true);
                }

            }




        }

        if (formType === "Player Tag" || formType === "tag_outstream") {


            if (floatingPosition_playertag !== ""
            ) {

                let payload = {
                    floatingPos: floatingPosition_playertag,
                }


                setButtonProcessing(true)


                let status = Cookies.get("token_xapads_ssp") ? true : false;
                if (status) {
                    let token = Cookies.get("token_xapads_ssp");

                    axios
                        .put(configData.SERVER_URL + `zone/editAniviewZone?zoneId=` + id, payload, {
                            headers: {
                                'Content-Type': 'application/json',
                                "x-access-token": token,
                            },
                        })
                        .then((response) => {
                            notifysuccess(response.data.message);
                            handlePageViewChange("table", "yes")
                            resetFormView()
                        })
                        .catch((error) => {
                            if (error?.response) {
                                if (error.response.data.message?.length !== 0) {
                                    notifyfailure(error.response.data.message);
                                    setButtonProcessing(false)
                                }
                            } else {
                                notifycatch();
                                setButtonProcessing(false)
                            }
                            // setButtonValue(false);
                        });
                }

            }



        }

        else if (formType === "vast_aniview") {
            if (channelName_vast_aniview !== "" &&
                eCpm_vast_aniview !== ""
            ) {
                if (
                    channelNameIsRequiredError_vast_aniview === false &&
                    eCpmIsRequiredError_vast_aniview === false &&
                    eCpmValidError_vast_aniview === false
                ) {

                    let payload = {
                        formType: formType,
                        environment: platformType_vast_aniview,
                        channelName: channelName_vast_aniview,
                        fixed_ecpm: Number(eCpm_vast_aniview),
                        p_name: p_name_vast_aniview,
                        p_aniviewId: p_aniviewId_vast_aniview
                    }


                    setButtonProcessing(true)

                    let status = Cookies.get("token_xapads_ssp") ? true : false;
                    if (status) {
                        let token = Cookies.get("token_xapads_ssp");
                        axios
                            .put(configData.SERVER_URL + `zone/editVastZoneAniview?zoneId=` + id, payload, {
                                headers: {
                                    "Content-Type": "application/json",
                                    "x-access-token": token,
                                },
                            })
                            .then((response) => {
                                notifysuccess(response.data.message);
                                handlePageViewChange("table", "yes")
                                resetFormView()
                            })
                            .catch((error) => {
                                if (error?.response) {
                                    if (error.response.data.message?.length !== 0) {
                                        notifyfailure(error.response.data.message);
                                        setButtonProcessing(false)
                                    }
                                } else {
                                    notifycatch();
                                    setButtonProcessing(false)
                                }
                            });
                    }
                }
            } else {
                if (channelName_vast_aniview === "") {
                    setChannelNameIsRequiredError_vast_aniview(true);
                }
                if (eCpm_vast_aniview === "") {
                    setECpmIsRequiredError_vast_aniview(true);
                }
            }



        }
    }










    return (
        <>


            <div className="container_box--wrapper pt_header">
                <div className="container_box--breadcrumb">
                    <ul className="container_box--breadcrumb-list">
                        <li>
                            <Link onClick={() => {
                                handlePageViewChange("table", "no")
                                resetFormView()
                            }}>
                                <img src={zoneIcon} alt="USP" /> Zones
                            </Link>
                        </li>
                        <li className="primary">View</li>
                    </ul>
                </div>
                <div className="container_box--wrapper--title">
                    <div className="back_btn_d2">
                        <img src={backButton} className="img-fluid" alt=""
                            onClick={() => {
                                handlePageViewChange("table", "no")
                                resetFormView()
                            }}
                        />
                        <h1 className="heading">
                            {zoneViewName + " (" + id + ")"}
                        </h1>
                    </div>
                </div>
                {formVisible &&
                    <div className="container_box--content pt_20">
                        <div className="container_box--width">
                            <Row gutter={16}>
                                <Col span={8}>
                                    <div className="container_box--label-info">
                                        <label>Zone Type</label>
                                        <p className="sub_text">Choose your zone type.</p>
                                    </div>
                                </Col>

                                <Col span={16}>
                                    <div className="container_box--form-container">
                                        <Row gutter={16}>
                                            <Col span={24}>
                                                <div className="form_content_block--group mb_0">
                                                    <label className="form_label">Zone Type * </label>
                                                    <Select
                                                        showSearch={false}
                                                        optionFilterProp="label"
                                                        className="form_select basic no_search"
                                                        // open={true}
                                                        value={formType}

                                                        options={formTypeOption}
                                                        disabled
                                                    />
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                </Col>
                            </Row>

                            {formType === "Prebid" ? (
                                <>
                                    <Row gutter={16}>
                                        <Col span={8}>
                                            <div className="container_box--label-info">
                                                <label>General details</label>
                                                <p className="sub_text">Please enter zone details</p>
                                            </div>
                                        </Col>

                                        <Col span={16}>
                                            <div className={role === "admin" ? "container_box--form-container mb-0" : "container_box--form-container"} >
                                                <Row gutter={16}>
                                                    <Col span={24}>
                                                        <div className="form_content_block--group">
                                                            <label className="form_label">
                                                                Traffic Type *
                                                            </label>
                                                            <Radio.Group

                                                                value={platformType_prebid}
                                                                className="form_radio equal_space"
                                                                disabled
                                                            >
                                                                <Radio className="radio_btn" value="Website">
                                                                    Website
                                                                </Radio>
                                                                <Radio className="radio_btn" value="Inapp">
                                                                    Inapp
                                                                </Radio>
                                                            </Radio.Group>
                                                        </div>
                                                        <div className="form_content_block--group">
                                                            <label className="form_label">Format Type *</label>
                                                            {/* <Select
                                                                optionFilterProp="label"
                                                                className="form_select basic no_search"
                                                                value={formatType_prebid}

                                                                options={formatTypeOptions_prebid}
                                                                disabled
                                                            /> */}


                                                            <div className='new_cls_for_checkboxgroup_d2'>
                                                                <Checkbox.Group className="form_checkbox equal_space" value={formatType_prebid} disabled>
                                                                    <Checkbox className="checkbox_btn" value="Banner">
                                                                        Banner
                                                                    </Checkbox>
                                                                    <Checkbox className="checkbox_btn" value="Video">
                                                                        Video
                                                                    </Checkbox>
                                                                    <Checkbox className="checkbox_btn" value="Native">
                                                                        Native
                                                                    </Checkbox>
                                                                </Checkbox.Group>
                                                            </div>
                                                            <span className="error_content">{formatTypeIsRequiredError_prebid && <> Minimum 1 selection is required</>} </span>
                                                        </div>
                                                        {formatType_prebid?.includes("Banner") && (
                                                            <div className="form_content_block--group">
                                                                <label className="form_label">
                                                                    In Banner Video Allow *
                                                                </label>
                                                                <Radio.Group

                                                                    value={bannerCheckbox_prebid}
                                                                    className="form_radio equal_space"
                                                                    disabled
                                                                >
                                                                    <Radio className="radio_btn" value={true}>
                                                                        Yes
                                                                    </Radio>
                                                                    <Radio className="radio_btn" value={false}>
                                                                        No
                                                                    </Radio>
                                                                </Radio.Group>

                                                                <span className="error_content">
                                                                    <></>
                                                                </span>
                                                            </div>
                                                        )}
                                                        <div className="hr_custom my_24"></div>
                                                        <div className="form_content_block--group">
                                                            <label className="form_label">Zone Name *</label>
                                                            <Input
                                                                className="form_control basic"
                                                                value={zoneName_prebid}

                                                                autocomplete="off"
                                                                disabled
                                                            />
                                                            <span className="error_content">
                                                                <></>
                                                            </span>
                                                        </div>
                                                        <div className="form_content_block--group">
                                                            <div className="primary_checkbox">
                                                                <Checkbox
                                                                    id="zone_checkbox_prebid"
                                                                    name="zone_checkbox_prebid"
                                                                    checked={zoneActiveCheckbox_prebid}

                                                                    disabled
                                                                >
                                                                    <span className="form_label">
                                                                        Is Zone Active?
                                                                    </span>
                                                                </Checkbox>
                                                            </div>
                                                        </div>
                                                        <div className="form_content_block--group mb_0">
                                                            <label className="form_label">
                                                                Integration Type *
                                                            </label>
                                                            <Select
                                                                optionFilterProp="label"
                                                                className="form_select basic no_search"
                                                                value={integrationType_prebid}

                                                                options={integrationTypeOptions_prebid}
                                                                disabled
                                                            />
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </Col>
                                    </Row>
                                    {role !== "admin" && (
                                        <>
                                            <Row gutter={16}>
                                                <Col span={8}>
                                                    <div className="container_box--label-info">
                                                        <label>Limits</label>
                                                        <p className="sub_text">Enter your zone limits</p>
                                                    </div>
                                                </Col>

                                                <Col span={16}>
                                                    <div className="container_box--form-container ">
                                                        <Row gutter={16}>
                                                            <Col span={12}>
                                                                <div className="form_content_block--group mb_0">
                                                                    <label className="form_label">
                                                                        Requests per Day
                                                                    </label>
                                                                    <Input
                                                                        className="form_control basic"
                                                                        value={request_prebid}

                                                                        autocomplete="off"
                                                                        disabled
                                                                    />
                                                                </div>
                                                                <span className="error_content">
                                                                    <></>
                                                                </span>
                                                            </Col>
                                                            <Col span={12}>
                                                                <div className="form_content_block--group mb_0">
                                                                    <label className="form_label">
                                                                        Impressions per Day
                                                                    </label>
                                                                    <Input
                                                                        className="form_control basic"
                                                                        value={impression_prebid}

                                                                        autocomplete="off"
                                                                        disabled
                                                                    />
                                                                    <span className="error_content">
                                                                        <span className="error_content">
                                                                            <></>
                                                                        </span>
                                                                    </span>
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                </Col>
                                            </Row>
                                            <Row gutter={16}>
                                                <Col span={8}>
                                                    <div className="container_box--label-info">
                                                        <label>Remote Feed Type</label>
                                                    </div>
                                                </Col>

                                                <Col span={16}>
                                                    <div className="container_box--form-container mb_0">
                                                        {feedListRepeater.map((x, i) => {
                                                            return (
                                                                <Row gutter={16} className='formHtml' key={i}>
                                                                    <Col span={16}>
                                                                        <div className="form_content_block--group mb_0 hide_open_searchplaceholder_d2 hide_caret_after_select_value">
                                                                            <label className="form_label">
                                                                                Remote Feed Type *
                                                                            </label>
                                                                            <Select
                                                                                showSearch
                                                                                placeholder="-Select-"
                                                                                optionFilterProp="label"
                                                                                className='form_select basic'
                                                                                // options={feedListRepeaterOptions.filter(option => !feedListRepeater.reduce((acc, item) => {
                                                                                //     return acc.concat(item.feed_provider_id);
                                                                                // }, []).includes(option.value))}

                                                                                options={feedListRepeaterOptions.filter(option => {
                                                                                    const feedProviderIds = feedListRepeater.reduce((acc, item) => {
                                                                                        return acc.concat(item.feed_provider_id);
                                                                                    }, []);

                                                                                    // Filter options: include if not in feedProviderIds OR if it's the alwaysShowValue
                                                                                    return !feedProviderIds.includes(option.value) || option.value === x.feed_provider_id;
                                                                                })}

                                                                                value={x.feed_provider_id}
                                                                                onChange={(e) =>
                                                                                    handleChangeFeedProviderId(
                                                                                        e,
                                                                                        i,
                                                                                    )
                                                                                }
                                                                            />
                                                                            <span span className="error_content">{x.validation_feed_provider_id && <>This field is required</>}</span>
                                                                        </div>

                                                                    </Col>
                                                                    <Col span={8}>
                                                                        <div className="form_content_block--group mb_0">
                                                                            <label className="form_label"> Remote ID * </label>
                                                                            <div className='d-flex'>
                                                                                <Input className="form_control basic"
                                                                                    value={x.remote_id}
                                                                                    onChange={(e) =>
                                                                                        handleChangeRemoteId(
                                                                                            e,
                                                                                            i,
                                                                                        )
                                                                                    }
                                                                                />

                                                                                <div className='download_icon_d2 d-flex align-items-center justify-content-between'>
                                                                                    <img className='delete_form_icon' src={deleteIcon} alt="Delete" onClick={() => handleRemoveFeedListRepeater(i)} />
                                                                                </div>

                                                                            </div>
                                                                            <span span className="error_content">{x.validation_remote_id && <>This field is required</>}</span>
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                            )
                                                        })}
                                                        <Row>
                                                            <Col span={24}>
                                                                <div className='addnewform_d2'>
                                                                    <button className='btn w_fit_content' onClick={handleAddFeedListRepeater}>
                                                                        <img src={addIcon} alt='Add New' /> Add New
                                                                    </button>
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                </Col>
                                            </Row>

                                        </>
                                    )}
                                </>
                            ) : formType === "Open RTB" ? (
                                <>
                                    <Row gutter={16}>
                                        <Col span={8}>
                                            <div className="container_box--label-info">
                                                <label>General details</label>
                                                <p className="sub_text">Please enter zone details</p>
                                            </div>
                                        </Col>

                                        <Col span={16}>
                                            <div className={role === "admin" ? "container_box--form-container mb-0" : "container_box--form-container"} >
                                                <Row gutter={16}>
                                                    <Col span={24}>
                                                        <div className="form_content_block--group">
                                                            <label className="form_label">
                                                                Traffic Type *
                                                            </label>
                                                            <Radio.Group

                                                                value={platformType_openrtb}
                                                                className="form_radio equal_space"
                                                                disabled
                                                            >
                                                                <Radio className="radio_btn" value="Website">
                                                                    Website
                                                                </Radio>
                                                                <Radio className="radio_btn" value="Inapp">
                                                                    Inapp
                                                                </Radio>
                                                                <Radio className="radio_btn" value="CTV">
                                                                    CTV
                                                                </Radio>
                                                            </Radio.Group>
                                                        </div>
                                                        <div className="form_content_block--group">
                                                            <label className="form_label">Format Type *</label>
                                                            {platformType_openrtb === "CTV" ?
                                                                <div className='new_cls_for_checkboxgroup_d2'>
                                                                    <Checkbox.Group className="form_checkbox equal_space" value={["Video"]} disabled>
                                                                        <Checkbox className="checkbox_btn" value="Banner">
                                                                            Banner
                                                                        </Checkbox>
                                                                        <Checkbox className="checkbox_btn" value="Video">
                                                                            Video
                                                                        </Checkbox>
                                                                        <Checkbox className="checkbox_btn" value="Native">
                                                                            Native
                                                                        </Checkbox>
                                                                    </Checkbox.Group>
                                                                </div>
                                                                :
                                                                <>
                                                                    <div className='new_cls_for_checkboxgroup_d2'>
                                                                        <Checkbox.Group className="form_checkbox equal_space" value={formatType_openrtb} disabled>
                                                                            <Checkbox className="checkbox_btn" value="Banner">
                                                                                Banner
                                                                            </Checkbox>
                                                                            <Checkbox className="checkbox_btn" value="Video">
                                                                                Video
                                                                            </Checkbox>
                                                                            <Checkbox className="checkbox_btn" value="Native">
                                                                                Native
                                                                            </Checkbox>
                                                                        </Checkbox.Group>
                                                                    </div>

                                                                </>
                                                            }

                                                        </div>
                                                        {formatType_openrtb?.includes("Banner") && platformType_openrtb !== "CTV" && (
                                                            <div className="form_content_block--group">
                                                                <label className="form_label">
                                                                    In Banner Video Allow *
                                                                </label>
                                                                <Radio.Group

                                                                    value={bannerCheckbox_openrtb}
                                                                    className="form_radio equal_space"
                                                                    disabled
                                                                >
                                                                    <Radio className="radio_btn" value={true}>
                                                                        Yes
                                                                    </Radio>
                                                                    <Radio className="radio_btn" value={false}>
                                                                        No
                                                                    </Radio>
                                                                </Radio.Group>

                                                                <span className="error_content">
                                                                    <></>
                                                                </span>
                                                            </div>
                                                        )}
                                                        <div className="hr_custom my_24"></div>
                                                        <div className="form_content_block--group">
                                                            <label className="form_label">Zone Name *</label>
                                                            <Input
                                                                className="form_control basic"
                                                                value={zoneName_openrtb}
                                                                disabled
                                                                autocomplete="off"
                                                            />
                                                            <span className="error_content">
                                                                <></>
                                                            </span>
                                                        </div>
                                                        <div className="form_content_block--group">
                                                            <div className="primary_checkbox">
                                                                <Checkbox
                                                                    id="zone_checkbox_openrtb"
                                                                    name="zone_checkbox_openrtb"
                                                                    checked={zoneActiveCheckbox_openrtb}
                                                                    disabled

                                                                >
                                                                    <span className="form_label">
                                                                        Is Zone Active?
                                                                    </span>
                                                                </Checkbox>
                                                            </div>
                                                        </div>
                                                        <div className="form_content_block--group mb_0">
                                                            <label className="form_label">
                                                                Integration Type *
                                                            </label>
                                                            <Select
                                                                optionFilterProp="label"
                                                                className="form_select basic no_search"
                                                                value={integrationType_openrtb}
                                                                disabled
                                                                options={integrationTypeOptions_openrtb}
                                                            />
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </Col>
                                    </Row>
                                    {role !== "admin" && (
                                        <>
                                            <Row gutter={16}>
                                                <Col span={8}>
                                                    <div className="container_box--label-info">
                                                        <label>Limits</label>
                                                        <p className="sub_text">Enter your zone limits</p>
                                                    </div>
                                                </Col>

                                                <Col span={16}>
                                                    <div className="container_box--form-container ">
                                                        <Row gutter={16}>
                                                            <Col span={12}>
                                                                <div className="form_content_block--group mb_0">
                                                                    <label className="form_label">
                                                                        Requests per Day
                                                                    </label>
                                                                    <Input
                                                                        className="form_control basic"
                                                                        value={request_openrtb}
                                                                        disabled
                                                                        autocomplete="off"
                                                                    />
                                                                </div>
                                                                <span className="error_content">
                                                                    <></>
                                                                </span>
                                                            </Col>
                                                            <Col span={12}>
                                                                <div className="form_content_block--group mb_0">
                                                                    <label className="form_label">
                                                                        Impressions per Day
                                                                    </label>
                                                                    <Input
                                                                        className="form_control basic"
                                                                        value={impression_openrtb}
                                                                        disabled
                                                                        autocomplete="off"
                                                                    />
                                                                    <span className="error_content">
                                                                        <></>
                                                                    </span>
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                </Col>
                                            </Row>
                                            <Row gutter={16}>
                                                <Col span={8}>
                                                    <div className="container_box--label-info">
                                                        <label>Remote Feed Type</label>
                                                    </div>
                                                </Col>

                                                <Col span={16}>
                                                    <div className="container_box--form-container mb_0">
                                                        {feedListRepeater.map((x, i) => {
                                                            return (
                                                                <Row gutter={16} className='formHtml' key={i}>
                                                                    <Col span={16}>
                                                                        <div className="form_content_block--group mb_0 hide_open_searchplaceholder_d2 hide_caret_after_select_value">
                                                                            <label className="form_label">
                                                                                Remote Feed Type *
                                                                            </label>
                                                                            <Select
                                                                                showSearch
                                                                                placeholder="-Select-"
                                                                                optionFilterProp="label"
                                                                                className='form_select basic'
                                                                                // options={feedListRepeaterOptions.filter(option => !feedListRepeater.reduce((acc, item) => {
                                                                                //     return acc.concat(item.feed_provider_id);
                                                                                // }, []).includes(option.value))}

                                                                                options={feedListRepeaterOptions.filter(option => {
                                                                                    const feedProviderIds = feedListRepeater.reduce((acc, item) => {
                                                                                        return acc.concat(item.feed_provider_id);
                                                                                    }, []);

                                                                                    // Filter options: include if not in feedProviderIds OR if it's the alwaysShowValue
                                                                                    return !feedProviderIds.includes(option.value) || option.value === x.feed_provider_id;
                                                                                })}

                                                                                value={x.feed_provider_id}
                                                                                onChange={(e) =>
                                                                                    handleChangeFeedProviderId(
                                                                                        e,
                                                                                        i,
                                                                                    )
                                                                                }
                                                                            />
                                                                            <span span className="error_content">{x.validation_feed_provider_id && <>This field is required</>}</span>
                                                                        </div>

                                                                    </Col>
                                                                    <Col span={8}>
                                                                        <div className="form_content_block--group mb_0">
                                                                            <label className="form_label"> Remote ID * </label>
                                                                            <div className='d-flex'>
                                                                                <Input className="form_control basic"
                                                                                    value={x.remote_id}
                                                                                    onChange={(e) =>
                                                                                        handleChangeRemoteId(
                                                                                            e,
                                                                                            i,
                                                                                        )
                                                                                    }
                                                                                />

                                                                                <div className='download_icon_d2 d-flex align-items-center justify-content-between'>
                                                                                    <img className='delete_form_icon' src={deleteIcon} alt="Delete" onClick={() => handleRemoveFeedListRepeater(i)} />
                                                                                </div>

                                                                            </div>
                                                                            <span span className="error_content">{x.validation_remote_id && <>This field is required</>}</span>
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                            )
                                                        })}
                                                        <Row>
                                                            <Col span={24}>
                                                                <div className='addnewform_d2'>
                                                                    <button className='btn w_fit_content' onClick={handleAddFeedListRepeater}>
                                                                        <img src={addIcon} alt='Add New' /> Add New
                                                                    </button>
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </>
                                    )}
                                </>
                            ) :
                                formType === "Vast Zone" ?
                                    (
                                        <>
                                            <Row gutter={16}>
                                                <Col span={8}>
                                                    <div className="container_box--label-info">
                                                        <label>General details</label>
                                                        <p className="sub_text">Please enter zone details</p>
                                                    </div>
                                                </Col>

                                                <Col span={16}>
                                                    <div className={role === "admin" ? "container_box--form-container mb-0" : "container_box--form-container"} >
                                                        <Row gutter={16}>
                                                            <Col span={24}>
                                                                <div className="form_content_block--group">
                                                                    <label className="form_label">
                                                                        Traffic Type *
                                                                    </label>
                                                                    <Radio.Group

                                                                        value={platformType_vastzone}
                                                                        disabled
                                                                        className="form_radio equal_space"
                                                                    >
                                                                        <Radio className="radio_btn" value="Website">
                                                                            Website
                                                                        </Radio>
                                                                        <Radio className="radio_btn" value="Inapp">
                                                                            Inapp
                                                                        </Radio>
                                                                        <Radio className="radio_btn" value="CTV">
                                                                            CTV
                                                                        </Radio>
                                                                    </Radio.Group>
                                                                </div>
                                                                <div className="form_content_block--group">
                                                                    <label className="form_label">Stream Position *</label>
                                                                    {platformType_vastzone === "CTV" ?
                                                                        <Input
                                                                            className="form_control basic"
                                                                            value="Instream"
                                                                            autocomplete="off"
                                                                            disabled
                                                                        />
                                                                        :
                                                                        <Select
                                                                            optionFilterProp="label"
                                                                            className="form_select basic no_search"
                                                                            value={streamPosition_vastzone}
                                                                            disabled
                                                                            options={streamPositionOptions_vastzone}
                                                                        />
                                                                    }
                                                                </div>


                                                                <div className="form_content_block--group">
                                                                    <label className="form_label">Zone Name *</label>
                                                                    <Input
                                                                        className="form_control basic"
                                                                        value={zoneName_vastzone}
                                                                        disabled
                                                                        autocomplete="off"

                                                                    />
                                                                    <span className="error_content">
                                                                        <></>
                                                                    </span>
                                                                </div>
                                                                <div className="form_content_block--group">
                                                                    <div className="primary_checkbox">
                                                                        <Checkbox
                                                                            id="zone_checkbox_vastzone"
                                                                            name="zone_checkbox_vastzone"
                                                                            checked={zoneActiveCheckbox_vastzone}
                                                                            disabled
                                                                        >
                                                                            <span className="form_label">
                                                                                Is Zone Active?
                                                                            </span>
                                                                        </Checkbox>
                                                                    </div>
                                                                </div>
                                                                <Row gutter={16}>
                                                                    <Col span={12}>
                                                                        <div className="form_content_block--group mb_0">
                                                                            <label className='form_label'>Revenue Type *</label>
                                                                            <Select
                                                                                showSearch={false}
                                                                                optionFilterProp="label"
                                                                                className='form_select basic no_search'
                                                                                value={revenueType_vastzone}
                                                                                disabled
                                                                                options={revenueTypeOptions_vastzone}
                                                                            />
                                                                        </div>
                                                                    </Col>
                                                                    {revenueType_vastzone === "Fixed_Price" ?
                                                                        <Col span={12}>
                                                                            <div className="form_content_block--group mb_0">
                                                                                <label className='form_label'>&nbsp;</label>
                                                                                <Input
                                                                                    placeholder='Enter eCpm'
                                                                                    className={
                                                                                        eCpmIsRequiredError_vastzone
                                                                                            ? "form_control basic error"
                                                                                            : "form_control basic"
                                                                                    }
                                                                                    value={eCpm_vastzone}
                                                                                    onBlur={onBlurECpm_vastzone}
                                                                                    onChange={onChangeECpm_vastzone}
                                                                                    autocomplete="off"
                                                                                    disabled={role === "admin"}
                                                                                />
                                                                                <span className="error_content">
                                                                                    {eCpmIsRequiredError_vastzone && (
                                                                                        <> This field is required</>
                                                                                    )}
                                                                                    {eCpmValidError_vastzone && (
                                                                                        <> Value should be greater than 0 and less than 100</>
                                                                                    )}
                                                                                </span>
                                                                            </div>
                                                                        </Col>
                                                                        :
                                                                        <Col span={12}>
                                                                            <div className="form_content_block--group mb-0">
                                                                                <label className='form_label'>&nbsp;</label>
                                                                                <Input
                                                                                    placeholder='Enter Revshare'
                                                                                    className={
                                                                                        revSharePercentIsRequiredError_vastzone
                                                                                            ? "form_control basic error form_control_with_icon_d2"
                                                                                            : "form_control basic form_control_with_icon_d2"
                                                                                    }
                                                                                    value={revSharePercent_vastzone}
                                                                                    onBlur={onBlurRevSharePercent_vastzone}
                                                                                    onChange={onChangeRevSharePercent_vastzone}
                                                                                    autocomplete="off"
                                                                                    suffix={'%'}
                                                                                    disabled={role === "admin"}
                                                                                />
                                                                            </div>
                                                                            <span className="error_content">
                                                                                {revSharePercentIsRequiredError_vastzone && (
                                                                                    <> This field is required</>
                                                                                )}
                                                                                {revSharePercentValidError_vastzone && (
                                                                                    <> Value should be greater than 0 and less or equal to  80</>
                                                                                )}
                                                                            </span>
                                                                        </Col>
                                                                    }

                                                                </Row>

                                                            </Col>
                                                        </Row>
                                                    </div>
                                                </Col>
                                            </Row>
                                            {role !== "admin" && (
                                                <>
                                                    <Row gutter={16}>
                                                        <Col span={8}>
                                                            <div className="container_box--label-info">
                                                                <label>Limits</label>
                                                                <p className="sub_text">Enter your zone limits</p>
                                                            </div>
                                                        </Col>

                                                        <Col span={16}>
                                                            <div className="container_box--form-container ">
                                                                <Row gutter={16}>
                                                                    <Col span={12}>
                                                                        <div className="form_content_block--group mb_0">
                                                                            <label className="form_label">
                                                                                Requests per Day
                                                                            </label>
                                                                            <Input
                                                                                className="form_control basic"
                                                                                value={request_vastzone}
                                                                                disabled
                                                                                autocomplete="off"
                                                                            />
                                                                        </div>
                                                                        <span className="error_content">
                                                                            <></>
                                                                        </span>
                                                                    </Col>
                                                                    <Col span={12}>
                                                                        <div className="form_content_block--group mb_0">
                                                                            <label className="form_label">
                                                                                Impressions per Day
                                                                            </label>
                                                                            <Input
                                                                                className="form_control basic"
                                                                                value={impression_vastzone}
                                                                                disabled
                                                                                autocomplete="off"
                                                                            />
                                                                            <span className="error_content">
                                                                                <></>
                                                                            </span>
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                    <Row gutter={16}>
                                                        <Col span={8}>
                                                            <div className="container_box--label-info">
                                                                <label>Remote Feed Type</label>
                                                            </div>
                                                        </Col>

                                                        <Col span={16}>
                                                            <div className="container_box--form-container mb_0">
                                                                {feedListRepeater.map((x, i) => {
                                                                    return (
                                                                        <Row gutter={16} className='formHtml' key={i}>
                                                                            <Col span={16}>
                                                                                <div className="form_content_block--group mb_0 hide_open_searchplaceholder_d2 hide_caret_after_select_value">
                                                                                    <label className="form_label">
                                                                                        Remote Feed Type *
                                                                                    </label>
                                                                                    <Select
                                                                                        showSearch
                                                                                        placeholder="-Select-"
                                                                                        optionFilterProp="label"
                                                                                        className='form_select basic'
                                                                                        // options={feedListRepeaterOptions.filter(option => !feedListRepeater.reduce((acc, item) => {
                                                                                        //     return acc.concat(item.feed_provider_id);
                                                                                        // }, []).includes(option.value))}

                                                                                        options={feedListRepeaterOptions.filter(option => {
                                                                                            const feedProviderIds = feedListRepeater.reduce((acc, item) => {
                                                                                                return acc.concat(item.feed_provider_id);
                                                                                            }, []);

                                                                                            // Filter options: include if not in feedProviderIds OR if it's the alwaysShowValue
                                                                                            return !feedProviderIds.includes(option.value) || option.value === x.feed_provider_id;
                                                                                        })}

                                                                                        value={x.feed_provider_id}
                                                                                        onChange={(e) =>
                                                                                            handleChangeFeedProviderId(
                                                                                                e,
                                                                                                i,
                                                                                            )
                                                                                        }
                                                                                    />
                                                                                    <span span className="error_content">{x.validation_feed_provider_id && <>This field is required</>}</span>
                                                                                </div>

                                                                            </Col>
                                                                            <Col span={8}>
                                                                                <div className="form_content_block--group mb_0">
                                                                                    <label className="form_label"> Remote ID * </label>
                                                                                    <div className='d-flex'>
                                                                                        <Input className="form_control basic"
                                                                                            value={x.remote_id}
                                                                                            onChange={(e) =>
                                                                                                handleChangeRemoteId(
                                                                                                    e,
                                                                                                    i,
                                                                                                )
                                                                                            }
                                                                                        />

                                                                                        <div className='download_icon_d2 d-flex align-items-center justify-content-between'>
                                                                                            <img className='delete_form_icon' src={deleteIcon} alt="Delete" onClick={() => handleRemoveFeedListRepeater(i)} />
                                                                                        </div>

                                                                                    </div>
                                                                                    <span span className="error_content">{x.validation_remote_id && <>This field is required</>}</span>
                                                                                </div>
                                                                            </Col>
                                                                        </Row>
                                                                    )
                                                                })}
                                                                <Row>
                                                                    <Col span={24}>
                                                                        <div className='addnewform_d2'>
                                                                            <button className='btn w_fit_content' onClick={handleAddFeedListRepeater}>
                                                                                <img src={addIcon} alt='Add New' /> Add New
                                                                            </button>
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </>
                                            )}
                                        </>
                                    )
                                    :
                                    formType === "vast_aniview" ?
                                        <>
                                            <Row gutter={16}>
                                                <Col span={8}>
                                                    <div className="container_box--label-info">
                                                        <label>General details</label>
                                                        <p className="sub_text">Please enter zone details</p>
                                                    </div>
                                                </Col>

                                                <Col span={16}>
                                                    <div className="container_box--form-container">
                                                        <Row gutter={16}>
                                                            <Col span={24}>
                                                                <div className="form_content_block--group">
                                                                    <label className="form_label">
                                                                        Traffic Type *
                                                                    </label>
                                                                    <Radio.Group
                                                                        onChange={onChangePlatformType_vast_aniview}
                                                                        value={platformType_vast_aniview}
                                                                        className="form_radio equal_space"
                                                                        disabled={role === "admin"}
                                                                    >
                                                                        <Radio className="radio_btn" value="Website">
                                                                            Website
                                                                        </Radio>
                                                                        <Radio className="radio_btn" value="Inapp">
                                                                            Inapp
                                                                        </Radio>
                                                                        <Radio className="radio_btn" value="CTV">
                                                                            CTV
                                                                        </Radio>
                                                                    </Radio.Group>
                                                                </div>

                                                                <div className="form_content_block--group">
                                                                    <label className="form_label">Channel Name *</label>
                                                                    <Input
                                                                        className={
                                                                            channelNameIsRequiredError_vast_aniview
                                                                                ? "form_control basic error"
                                                                                : "form_control basic"
                                                                        }
                                                                        value={channelName_vast_aniview}
                                                                        onBlur={onBlurChannelName_vast_aniview}
                                                                        onChange={onChangeChannelName_vast_aniview}
                                                                        autocomplete="off"
                                                                        disabled={role === "admin"}
                                                                    />
                                                                    <span className="error_content">
                                                                        {channelNameIsRequiredError_vast_aniview && (
                                                                            <> This field is required</>
                                                                        )}
                                                                    </span>
                                                                </div>


                                                                <div className="form_content_block--group mb_0">
                                                                    <label className='form_label'>eCPM *</label>
                                                                    <Input
                                                                        placeholder='Enter eCpm'
                                                                        className={
                                                                            eCpmIsRequiredError_vast_aniview || eCpmValidError_vast_aniview
                                                                                ? "form_control basic error"
                                                                                : "form_control basic"
                                                                        }
                                                                        value={eCpm_vast_aniview}
                                                                        onBlur={onBlurECpm_vast_aniview}
                                                                        onChange={onChangeECpm_vast_aniview}
                                                                        autocomplete="off"
                                                                        disabled={role === "admin"}
                                                                    />
                                                                    <span className="error_content">
                                                                        {eCpmIsRequiredError_vast_aniview && (
                                                                            <> This field is required</>
                                                                        )}
                                                                        {eCpmValidError_vast_aniview && (
                                                                            <> Value should be greater than 0 and less than 100</>
                                                                        )}
                                                                    </span>
                                                                </div>

                                                            </Col>
                                                        </Row>
                                                    </div>
                                                </Col>
                                            </Row>


                                        </>
                                        :
                                        (formType === "Player Tag" || formType === "tag_outstream") ?
                                            <>
                                                <Row gutter={16}>
                                                    <Col span={8}>
                                                        <div className="container_box--label-info">
                                                            <label>General details</label>
                                                            <p className="sub_text">Please enter zone details</p>
                                                        </div>
                                                    </Col>

                                                    <Col span={16}>
                                                        <div className="container_box--form-container">
                                                            <Row gutter={16}>
                                                                <Col span={24}>
                                                                    <div className="form_content_block--group">
                                                                        <label className="form_label">
                                                                            Traffic Type *
                                                                        </label>
                                                                        <Radio.Group

                                                                            value={platformType_playertag}
                                                                            disabled
                                                                            className="form_radio equal_space"
                                                                        >
                                                                            <Radio className="radio_btn" value="Website">
                                                                                Website
                                                                            </Radio>
                                                                            <Radio className="radio_btn" value="Inapp">
                                                                                Inapp
                                                                            </Radio>

                                                                        </Radio.Group>
                                                                    </div>
                                                                    <div className="form_content_block--group">
                                                                        <label className="form_label">Player Mode *</label>
                                                                        <Select
                                                                            optionFilterProp="label"
                                                                            className="form_select basic no_search"
                                                                            value={playerMode_playertag}
                                                                            disabled

                                                                            options={playerModeOptions_playertag}
                                                                        />
                                                                    </div>


                                                                    <div className="form_content_block--group">
                                                                        <label className="form_label">Floating Position *</label>
                                                                        <Select
                                                                            optionFilterProp="label"
                                                                            className="form_select basic no_search"
                                                                            value={floatingPosition_playertag}
                                                                            onChange={onChangeFloatingPosition_playertag}
                                                                            options={formType === "tag_outstream" ? floatingPositionOptions_tag_outstream : floatingPositionOptions_playertag}
                                                                            disabled={role === "admin"}

                                                                        />
                                                                    </div>



                                                                    <div className="form_content_block--group">
                                                                        <label className="form_label">Channel Name *</label>
                                                                        <Input
                                                                            className="form_control basic"
                                                                            value={channelName_playertag}
                                                                            disabled
                                                                            autocomplete="off"
                                                                        />
                                                                        <span className="error_content">
                                                                            <></>
                                                                        </span>
                                                                    </div>


                                                                    <div className="form_content_block--group mb_0">
                                                                        <label className='form_label'>eCPM *</label>
                                                                        <Input
                                                                            placeholder='Enter eCpm'
                                                                            className="form_control basic"
                                                                            value={eCpm_playertag}
                                                                            disabled
                                                                            autocomplete="off"
                                                                        />
                                                                        <span className="error_content">
                                                                            <></>
                                                                        </span>
                                                                    </div>

                                                                </Col>
                                                            </Row>
                                                        </div>
                                                    </Col>
                                                </Row>

                                                <Row gutter={16}>
                                                    <Col span={8}>
                                                        <div className="container_box--label-info"

                                                        >
                                                            <label>CMS</label>
                                                            <p className='sub_text'>Upload your desired video</p>
                                                        </div>
                                                    </Col>

                                                    <Col span={16}>
                                                        <div className="form_content_block--group mb_0"

                                                        >


                                                            {mainTableVideo_playertag?.length > 0 &&
                                                                <>
                                                                    {mainTableVideo_playertag?.map((video, index) => (
                                                                        <>
                                                                            <div class="ant_upload_list--item">

                                                                                <div class="ant_upload_list--content gap_12">
                                                                                    <div className="thumbnail_content--video position-relative">
                                                                                        <button className='thumbnail_content--play'
                                                                                            onClick={() => { handleFullscreen1(index) }}
                                                                                        ><img src={playIcon} alt='USP' /></button>
                                                                                        <video
                                                                                            ref={el => videoRef1.current[index] = el}
                                                                                            width="138"
                                                                                            height="79"
                                                                                            controls={false}
                                                                                            className='video_thumb'
                                                                                            // onMouseEnter={handleMouseEnter}
                                                                                            // onMouseLeave={handleMouseLeave}
                                                                                            muted
                                                                                        >
                                                                                            <source src={video.url} />
                                                                                            Your browser does not support the video tag.
                                                                                        </video>
                                                                                    </div>

                                                                                    <div class="ant_upload_list--info">
                                                                                        <span class="ant_upload_list--info-name">{video?.url?.includes("blob") ? video?.filename : video?.url?.substring(video?.url?.lastIndexOf('/') + 1)}</span>
                                                                                        <span class="ant_upload_list--info-size">{video?.url?.includes("blob") ? video?.size / 1024 > 100 ? `${(video.size / (1024 * 1024)).toFixed(2)} MB` : `${(video.size / (1024)).toFixed(2)} KB` : ""}</span>
                                                                                    </div>
                                                                                </div>
                                                                                {/* <button type="link" class="download_icon download_icon_d2"
                                                                                onClick={() => {
                                                                                    const newArray = [...mainTableVideo_playertag];
                                                                                    newArray.splice(index, 1);
                                                                                    setMainTableVideo_playertag(newArray);
                                                                                }}
                                                                            >
                                                                                <img src={deleteIcon} alt="USP" />
                                                                            </button> */}

                                                                            </div>
                                                                        </>

                                                                    ))}
                                                                </>
                                                            }
                                                        </div>
                                                    </Col>

                                                </Row>

                                            </>
                                            :
                                            (
                                                <>
                                                    <Row gutter={16}>
                                                        <Col span={8}>
                                                            <div className="container_box--label-info">
                                                                <label>General details</label>
                                                                <p className="sub_text">Please enter zone details</p>
                                                            </div>
                                                        </Col>

                                                        <Col span={16}>
                                                            <div className="container_box--form-container ">
                                                                <Row gutter={16}>
                                                                    <Col span={24}>

                                                                        <div className="form_content_block--group">
                                                                            <label className="form_label">Account Name *</label>
                                                                            <Input
                                                                                className="form_control basic"
                                                                                value={accountName_gamtag}
                                                                                disabled
                                                                                autocomplete="off"
                                                                            />
                                                                            <span className="error_content">
                                                                                <></>
                                                                            </span>
                                                                        </div>

                                                                        <div className="form_content_block--group">
                                                                            <label className="form_label">Inventory Type *</label>
                                                                            <Input
                                                                                className="form_control basic"
                                                                                value="Video"
                                                                                autocomplete="off"
                                                                                disabled
                                                                            />
                                                                            <span className="error_content">
                                                                            </span>
                                                                        </div>


                                                                        <div className="form_content_block--group">
                                                                            <label className="form_label">
                                                                                Traffic Type *
                                                                            </label>
                                                                            <Radio.Group

                                                                                value={platformType_gamtag}
                                                                                className="form_radio equal_space"
                                                                                disabled
                                                                            >
                                                                                <Radio className="radio_btn" value="Website">
                                                                                    Website
                                                                                </Radio>
                                                                                <Radio className="radio_btn" value="Inapp">
                                                                                    Inapp
                                                                                </Radio>
                                                                                <Radio className="radio_btn" value="CTV">
                                                                                    CTV
                                                                                </Radio>
                                                                            </Radio.Group>
                                                                        </div>

                                                                        <div className="form_content_block--group">
                                                                            <label className="form_label">Ownership *</label>
                                                                            <Select
                                                                                optionFilterProp="label"
                                                                                className="form_select basic no_search"
                                                                                value={ownership_gamtag}
                                                                                disabled
                                                                                options={ownershipOptions_gamtag}
                                                                            />
                                                                        </div>

                                                                        <div className="form_content_block--group">
                                                                            <label className="form_label">VAST Version *</label>
                                                                            <Select
                                                                                optionFilterProp="label"
                                                                                className="form_select basic no_search"
                                                                                value={vastVersion_gamtag}
                                                                                disabled
                                                                                options={vastVersionOptions_gamtag}
                                                                            />
                                                                        </div>

                                                                        <div className="form_content_block--group mb_0">
                                                                            <label className="form_label">eCPM *</label>
                                                                            <Select
                                                                                optionFilterProp="label"
                                                                                className="form_select basic no_search"
                                                                                value={eCPM_gamtag}
                                                                                disabled

                                                                                options={eCPMOptions_gamtag}
                                                                            />
                                                                        </div>

                                                                    </Col>
                                                                </Row>
                                                            </div>
                                                        </Col>
                                                    </Row>

                                                </>
                                            )

                            }

                        </div>
                        {/* <div className={role !== "admin" && (formType === "Vast Zone" || formType === "Player Tag") ? 'hr_custom mb_20' : 'mb_20'}></div> */}
                        <div className={role !== "admin" && (formType === "Vast Zone" || formType === "Player Tag" || formType === "tag_outstream") ? '' : ''}></div>
                        <div className="height_89_d2"></div>
                        {role !== "admin"
                            && (formType === "Prebid" || formType === "Open RTB" || formType === "Vast Zone" || formType === "Player Tag" || formType === "tag_outstream" || formType === "vast_aniview")
                            &&
                            <div className="btn_group justify-content-end gap_8 pb_50 edit_view_fixedbtn_d2">
                                {buttonProcessing ?
                                    <>
                                        {/* <button className="btn btn_white_outline w_fit_content"
                                            disabled
                                        >
                                            Discard
                                        </button> */}
                                        <button
                                            className="w_120_d2 btn btn_primary w_fit_content loader"

                                        >
                                            <span>Save</span>

                                            <img
                                                src={loaderIcon}
                                                alt="USP"
                                                className="loader_icon"
                                            />
                                        </button>
                                    </> :
                                    <>
                                        <button className="w_120_d2 btn btn_white_outline w_fit_content"
                                            onClick={() => {
                                                handlePageViewChange("table", "no")
                                                resetFormView()
                                            }}
                                        >
                                            Discard
                                        </button>
                                        <button
                                            className="w_120_d2 btn btn_primary w_fit_content"
                                            onClick={handleSubmit}
                                            disabled={
                                                (formType === "Prebid" && JSON.stringify(feedListRepeater) === JSON.stringify(feedListRepeaterOldData)) ||
                                                (formType === "Open RTB" && JSON.stringify(feedListRepeater) === JSON.stringify(feedListRepeaterOldData)) ||
                                                ((formType === "Player Tag" || formType === "tag_outstream") && floatingPosition_playertag === floatingPosition_playertag_prev) ||
                                                ((formType === "Vast Zone" && revenueType_vastzone === "Fixed_Price" && eCpm_vastzone === eCpm_vastzone_prev) && (formType === "Vast Zone" && JSON.stringify(feedListRepeater) === JSON.stringify(feedListRepeaterOldData))) ||
                                                ((formType === "Vast Zone" && revenueType_vastzone === "Revshare" && revSharePercent_vastzone === revSharePercent_vastzone_prev) && (formType === "Vast Zone" && JSON.stringify(feedListRepeater) === JSON.stringify(feedListRepeaterOldData))) ||
                                                (formType === "vast_aniview" && platformType_vast_aniview === platformType_vast_aniview_prev && channelName_vast_aniview === channelName_vast_aniview_prev && eCpm_vast_aniview === eCpm_vast_aniview_prev)

                                            }>
                                            Save
                                        </button>
                                    </>
                                }

                            </div>
                        }


                    </div>
                }
                {!formVisible &&
                    <div className="d-flex justify-content-center align-items-center mt-5 pt-5">
                        <img src={FullLoader} className="mt-5" width={50} height={50} alt="" />
                    </div>
                }
            </div >

        </>
    );
};

export default ZoneViewEdit;
